<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title mb-4">{{ $t("cogsReport") }}</div>
      <div class="mt-3 mb-2">
        <div class="row">
          <!-- SELECT DROPDOWN -->
          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="getCOGSReportFromDate"
                  @click="
                    onCOGSDropDownHandler({ event: null, name: 'fromDate' })
                  "
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  @selected="
                    onCOGSDropDownHandler({ event: $event, name: 'fromDate' })
                  "
                  :value="getCOGSReportFromDate"
                  typeable
                ></Datepicker>
                <label :class="getCOGSReportFromDate ? 'active' : ''">{{
                  $t("startdate")
                }}</label>
              </div>
            </div>
          </div>

          <!-- <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class>
              <date-picker
                lang="en"
                type="time"
                format="hh:mm a"
                :minute-step="1"
                class="time_picker"
                placeholder="Show Time"
                name="showtime"
                id="showtime"
              ></date-picker>
            </div>
          </div>-->

          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="getCOGSReportEndDate"
                  @click="
                    onCOGSDropDownHandler({ event: null, name: 'endDate' })
                  "
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  @selected="
                    onCOGSDropDownHandler({ event: $event, name: 'endDate' })
                  "
                  :value="getCOGSReportEndDate"
                  typeable
                ></Datepicker>
                <label :class="getCOGSReportEndDate ? 'active' : ''">{{
                  $t("enddate")
                }}</label>
              </div>
            </div>
          </div>

          <!-- <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class>
              <date-picker
                lang="en"
                type="time"
                format="hh:mm a"
                :minute-step="1"
                class="time_picker"
                placeholder="End Show Time"
                name="showtime"
                id="showtime"
              ></date-picker>
            </div>
          </div>-->

          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="dropdown-curve-container mr-2">
              <label :class="getCOGSSelectedCinema ? 'shift-up' : ''"
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <b-dropdown
                :text="getCOGSSelectedCinema"
                variant="dropdown-curve"
                class="w-100"
                :disabled="isRoleID"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    :placeholder="$tc('searchCinema')"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchCinema()"
                    v-on:keydown="onSearchCinema()"
                    v-on:search="onSearchCinema()"
                    v-model="searchCinema"
                  />
                </div>
                <b-dropdown-item
                  v-for="(dropdownItem, dropdownIndex) in Cinemas"
                  :key="dropdownIndex"
                  @click="
                    onCOGSDropDownHandler({
                      event: $event,
                      name: 'isCinema',
                      selectedItem: dropdownItem,
                      index: dropdownIndex
                    });
                    searchCinema = '';
                    onSearchCinema();
                    onSelectCinema(dropdownItem);
                  "
                  >{{ dropdownItem.cine_name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>

          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="dropdown-curve-container mr-2">
              <label
                :class="getCOGSSelectedRawMaterialCategory ? 'shift-up' : ''"
                >{{ $t("select") }} {{ $tc("category", 1) }}</label
              >
              <b-dropdown
                :text="getCOGSSelectedRawMaterialCategory"
                variant="dropdown-curve"
                class="w-100"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    :placeholder="$tc(searchRawMaterial)"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchRawMaterial()"
                    v-on:keydown="onSearchRawMaterial()"
                    v-on:search="onSearchRawMaterial()"
                    v-model="searchRawMaterial"
                  />
                </div>
                <b-dropdown-item
                  v-for="(dropdownItem, dropdownIndex) in rawMaterialCategories"
                  :key="dropdownIndex"
                  @click="
                    onCOGSDropDownHandler({
                      event: $event,
                      name: 'isRawMaterialCategory',
                      selectedItem: dropdownItem,
                      index: dropdownIndex
                    });
                    searchRawMaterial = '';
                    onSearchRawMaterial();
                  "
                  >{{ dropdownItem.rmc_category }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>
          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <button @click="onFetchCOGSReports" class="btn-blue-lg w-100">
              {{ $tc("getReport") }}
            </button>
          </div>


          <div
          v-if="getCOGSReportData.length > 0"
        class="col-lg-8 col-xl-9 align-self-center mb-4 d-flex justify-content-end align-items-center"
      >
        <div>{{ $t("download") }} as:</div>
        <a
          v-if="getCOGSReportsPDFFileName"
          :href="BASE_URL + getCOGSReportsPDFFileName"
          target="_blank"
          download
          title="Download as PDF"
        >
          <img src="@/assets/img/icons/pdf-icon.svg" height="25" width="25" />
        </a>
        <!-- <a
          v-if="getCOGSReportsExcelFileName"
          :href="BASE_URL + getCOGSReportsExcelFileName"
          target="_blank"
          title="Download as Excel"
          download
        >
          <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
        </a> -->
         <a target="_blank" title="Download as Excel" @click="excelDownload()">
          <img class="mx-2" src="@/assets/img/icons/excel.svg" height="25" width="25" />
          </a>
      </div>

        </div>
      </div>
      <div class="swc-report" style="overflow-x: scroll">
        <table class="swc-report-table" border="1" style="width: auto">
          <thead class="bg-lightgrey" style="white-space: nowrap">
            <tr>
              <th>{{ $tc("rawmaterials") }}</th>
              <th>UOM</th>
              <th>{{ $t("purchase") }} {{ $t("rate") }}</th>
              <th>{{ $t("openingStock") }}</th>
              <th>{{ $t("purchase") }}</th>
              <th>{{ $t("purchase") }} {{ $t("return") }}</th>
              <th>{{ $t("tranferInFromUnit") }}</th>
              <th>{{ $t("transferOutUnit") }}</th>
              <th>{{ $t("standard") }} {{ $t("consumption") }}</th>
              <th>{{ $t("system") }} {{ $t("stock") }}</th>
              <th>{{ $t("wastage") }}</th>
              <th>{{ $t("variance") }}</th>
              <!-- <th>Increase</th> -->
              <th>{{ "Total Wastage/Variance" }}</th>
            </tr>
            <!-- <tr style="text-align: right">
              <th
                rowspan="2"
                style="vertical-align: bottom; white-space: nowrap"
              >Hot Beverage Consumable</th>
              <th></th>
              <th class="font-weight-bold text-left">Qty:</th>
              <th>2,574.00</th>
              <th>0.00</th>
              <th>0.00</th>
              <th>0.00</th>
              <th>0.00</th>
              <th>680.00</th>
              <th>1,894.00</th>
              <th>0.00</th>
              <th>0.00</th>
              <th>0.00</th>
              <th>0.00</th>
            </tr>
            <tr style="text-align: right">
              <th></th>
              <th class="font-weight-bold text-left">Value:</th>
              <th>545.83</th>
              <th>0.00</th>
              <th>0.00</th>
              <th>0.00</th>
              <th>0.00</th>
              <th>151.64</th>
              <th>398.74</th>
              <th>0.00</th>
              <th>0.00</th>
              <th>0.00</th>
              <th>0.00</th>
            </tr>-->
          </thead>
          <tbody v-if="getCOGSReportData && getCOGSReportData.length == 0">
            <tr rowspan="13">
              <td colspan="13">
                <!-- {{ `No Records Found` }} -->
                <NoRecords />
              </td>
            </tr>
          </tbody>
          <tbody
            v-else
            v-for="(RawMaterialCategory,
            RawMaterialCategoryIndex) in getCOGSReportData"
            :key="RawMaterialCategoryIndex"
            class="sph-report"
          >
            <tr>
              <td colspan="2" class="font-weight-bold text-left" style="border-right-color: transparent;">
                {{ RawMaterialCategory.RawMaterials[0].rmc_category }}
              </td>
              <td style="border-right-color: transparent;"></td>
              <td style="border-right-color: transparent;"></td>
              <td style="border-right-color: transparent;"></td>
              <td style="border-right-color: transparent;"></td>
              <td style="border-right-color: transparent;"></td>
              <td style="border-right-color: transparent;"></td>
              <td style="border-right-color: transparent;"></td>
              <td style="border-right-color: transparent;"></td>
              <td style="border-right-color: transparent;"></td>
              <td style="border-right-color: transparent;"></td>
              <!-- <td></td> -->
              <td style="border-right-color: transparent;"></td>
            </tr>
            <tr
              v-for="(singleRawItem,
              singleRawItemKey) in RawMaterialCategory.RawMaterials"
              :key="singleRawItemKey"
              class="text-right"
            >
              <td class="text-left">{{ singleRawItem.rm_name }}</td>
              <td class="text-left">{{ singleRawItem.uom_short_form }}</td>
              <td>{{ singleRawItem.purchase_rate | RoundOff }}</td>
              <td>
                <div>{{ currFormat(singleRawItem.opening_stock) }}</div>
                <div>
                  {{
                    currFormat(
                      singleRawItem.opening_stock * singleRawItem.purchase_rate
                    )
                  }}
                </div>
              </td>
              <td>
                <div>{{ singleRawItem.purchase }}</div>
                <div>
                  {{
                    currFormat(
                      singleRawItem.purchase * singleRawItem.purchase_rate
                    )
                  }}
                </div>
              </td>
              <td>
                <div>{{ currFormat(singleRawItem.fgr_quantity) || 0.0 }}</div>
                <div>
                  {{ currFormat((singleRawItem.fgr_quantity || 0) * singleRawItem.purchase_rate) || 0.0 }}
                </div>
              </td>
              <!-- transfer In -->
              <td>
                <div>{{ currFormat(singleRawItem.transfer_in) || 0.0 }}</div>
                <div>
                  {{
                    currFormat(
                      (singleRawItem.transfer_in || 0) *
                        singleRawItem.purchase_rate
                    )
                  }}
                </div>
              </td>
              <!-- Transfer Out -->
              <td>
                <div>{{ currFormat(singleRawItem.transfer_out) || 0.0 }}</div>
                <div>
                  {{
                    currFormat(
                      (singleRawItem.transfer_out || 0) *
                        singleRawItem.purchase_rate
                    )
                  }}
                </div>
              </td>
              <!-- std consumption -->
              <td>
                <div>{{ currFormat(singleRawItem.standard_consumption) }}</div>
                <div>
                  {{
                    currFormat(
                      singleRawItem.standard_consumption *
                        singleRawItem.purchase_rate
                    )
                  }}
                </div>
              </td>
              <td>
                <div>{{ currFormat(singleRawItem.system_stock) }}</div>
                <div>
                  {{
                    currFormat(
                      singleRawItem.system_stock * singleRawItem.purchase_rate
                    )
                  }}
                </div>
              </td>
              <td>
                <div>{{ currFormat(singleRawItem.wastage) || 0 }}</div>
                <div>
                  {{
                    currFormat(
                      singleRawItem.wastage * singleRawItem.purchase_rate
                    )
                  }}
                </div>
              </td>
              <td>
                <div>{{ currFormat(singleRawItem.ps_variance) || 0 }}</div>
                <div>
                  {{
                    currFormat(
                      singleRawItem.ps_variance * singleRawItem.purchase_rate
                    )
                  }}
                </div>
              </td>
              <!-- <td>
                <div>3.50</div>
                <div>94.50</div>
              </td>-->
              <td>
                <div>
                  {{
                    currFormat(
                      singleRawItem.wastage + getOnlyPositiveNumber(singleRawItem.ps_variance)
                    )
                  }}
                </div>
                <div>
                  {{
                    currFormat(
                      (singleRawItem.wastage + getOnlyPositiveNumber(singleRawItem.ps_variance)) *
                        singleRawItem.purchase_rate
                    )
                  }}
                </div>
              </td>
            </tr>
            <!-- <tr class="text-right">
              <td class="text-left">Imported Corn</td>
              <td class="text-left">Kg</td>
              <td>129.00</td>
              <td>
                <div>418.60</div>
                <div>533,999.40</div>
              </td>
              <td>
                <div>0.00</div>
                <div>0.00</div>
              </td>
              <td>
                <div>0.00</div>
                <div>0.00</div>
              </td>
              <td>
                <div>0.00</div>
                <div>0.00</div>
              </td>
              <td>
                <div>0.00</div>
                <div>0.00</div>
              </td>
              <td>
                <div>321.71</div>
                <div>41,500.76</div>
              </td>
              <td>
                <div>76.54</div>
                <div>9,873.66</div>
              </td>
              <td>
                <div>20.35</div>
                <div>2,625.16</div>
              </td>
              <td>
                <div>0.00</div>
                <div>0.00</div>
              </td>
              <td>
                <div>0.00</div>
                <div>0.17</div>
              </td>
              <td>
                <div>20.35</div>
                <div>2,624.98</div>
              </td>
            </tr>-->
            <tr style="text-align: right" class="bg-lightgrey">
              <th
                rowspan="2"
                style="vertical-align: center; white-space: nowrap; text-align: left;"
              >
                {{ RawMaterialCategory.RawMaterials[0].rmc_category }} <span class="text-uppercase">{{$t("total")}}</span>
              </th>
              <th></th>
              <th class="font-weight-bold text-left">Qty:</th>
              <th>
                {{
                  currFormat(
                    RawMaterialCategory.RawMaterials.reduce(
                      (acc, { opening_stock }) => acc + opening_stock,
                      0
                    )
                  )
                }}
              </th>
              <th>
                {{
                  currFormat(
                    RawMaterialCategory.RawMaterials.reduce(
                      (acc, { purchase }) => acc + purchase,
                      0
                    )
                  )
                }}
              </th>
              <th>
                {{
                  currFormat(
                    RawMaterialCategory.RawMaterials.reduce(
                      (acc, { fgr_quantity }) => acc + fgr_quantity,
                      0
                    )
                  )
                }}
              </th>
              <th>
                {{
                  currFormat(
                    RawMaterialCategory.RawMaterials.reduce(
                      (acc, { transfer_in }) => acc + transfer_in,
                      0
                    )
                  )
                }}
              </th>
              <th>
                {{
                  currFormat(
                    RawMaterialCategory.RawMaterials.reduce(
                      (acc, { transfer_out }) => acc + transfer_out,
                      0
                    )
                  )
                }}
              </th>
              <th>
                {{
                  currFormat(
                    RawMaterialCategory.RawMaterials.reduce(
                      (acc, { standard_consumption }) =>
                        acc + standard_consumption,
                      0
                    )
                  )
                }}
              </th>
              <th>
                {{
                  currFormat(
                    RawMaterialCategory.RawMaterials.reduce(
                      (acc, { system_stock }) => acc + system_stock,
                      0
                    )
                  )
                }}
              </th>
              <th>
                {{
                  currFormat(
                    RawMaterialCategory.RawMaterials.reduce(
                      (acc, { wastage }) => acc + wastage,
                      0
                    )
                  )
                }}
              </th>
              <th>
                {{
                  currFormat(
                    RawMaterialCategory.RawMaterials.reduce(
                      (acc, { ps_variance }) => acc + ps_variance,
                      0
                    )
                  )
                }}
              </th>
              <!-- <th>0.00</th> -->
              <th>
                {{
                  currFormat(
                    RawMaterialCategory.RawMaterials.reduce(
                      (acc, { wastage, ps_variance }) =>
                        acc + (wastage + getOnlyPositiveNumber(ps_variance)),
                      0
                    )
                  )
                }}
              </th>
            </tr>
            <tr style="text-align: right" class="bg-lightgrey">
              <th style=""></th>
              <th class="font-weight-bold text-left">Value:</th>
              <th>
                {{
                  currFormat(
                    RawMaterialCategory.RawMaterials.reduce(
                      (acc, { opening_stock, purchase_rate }) =>
                        acc + opening_stock * purchase_rate,
                      0
                    )
                  )
                }}
              </th>
              <th>
                {{
                  currFormat(
                    RawMaterialCategory.RawMaterials.reduce(
                      (acc, { purchase, purchase_rate }) =>
                        acc + purchase * purchase_rate,
                      0
                    )
                  )
                }}
              </th>
              <th>
                {{
                  currFormat(
                    RawMaterialCategory.RawMaterials.reduce(
                      (acc, { fgr_quantity, purchase_rate }) =>
                        acc + fgr_quantity * purchase_rate,
                      0
                    )
                  )
                }}
              </th>
              <th>
                {{
                  currFormat(
                    RawMaterialCategory.RawMaterials.reduce(
                      (acc, { transfer_in, purchase_rate }) =>
                        acc + transfer_in * purchase_rate,
                      0
                    )
                  )
                }}
              </th>
              <th>
                {{
                  currFormat(
                    RawMaterialCategory.RawMaterials.reduce(
                      (acc, { transfer_out, purchase_rate }) =>
                        acc + transfer_out * purchase_rate,
                      0
                    )
                  )
                }}
              </th>
              <th>
                {{
                  currFormat(
                    RawMaterialCategory.RawMaterials.reduce(
                      (acc, { standard_consumption, purchase_rate }) =>
                        acc + standard_consumption * purchase_rate,
                      0
                    )
                  )
                }}
              </th>
              <th>
                {{
                  currFormat(
                    RawMaterialCategory.RawMaterials.reduce(
                      (acc, { system_stock, purchase_rate }) =>
                        acc + system_stock * purchase_rate,
                      0
                    )
                  )
                }}
              </th>
              <th>
                {{
                  currFormat(
                    RawMaterialCategory.RawMaterials.reduce(
                      (acc, { wastage, purchase_rate }) =>
                        acc + wastage * purchase_rate,
                      0
                    )
                  )
                }}
              </th>
              <th>
                {{
                  currFormat(
                    RawMaterialCategory.RawMaterials.reduce(
                      (acc, { ps_variance, purchase_rate }) =>
                        acc + ps_variance * purchase_rate,
                      0
                    )
                  )
                }}
              </th>
              <th>
                {{
                  currFormat(
                    RawMaterialCategory.RawMaterials.reduce(
                      (acc, { wastage, ps_variance, purchase_rate }) =>
                        acc + (wastage + getOnlyPositiveNumber(ps_variance)) * purchase_rate,
                      0
                    )
                  )
                }}
              </th>
              <!-- <th>0.00</th> -->
              <!-- <th>0.00</th> -->
            </tr>
            <tr
              v-if="
                RawMaterialCategoryIndex == getCOGSReportData.length - 1 &&
                  false
              "
              style="text-align: right"
            >
              <th style="vertical-align: bottom; white-space: nowrap"></th>
              <th></th>
              <th class="font-weight-bold text-left">Qty:</th>
              <!-- <th class="font-weight-bold text-left">Value :</th> -->
              <th>
                {{
                  currFormat(
                    getNonReccoRecords.reduce(
                      (acc, { opening_stock }) => acc + opening_stock,
                      0
                    )
                  )
                }}
              </th>
              <th>
                {{
                  currFormat(
                    getNonReccoRecords.reduce(
                      (acc, { purchase }) => acc + purchase,
                      0
                    )
                  )
                }}
              </th>
              <th>
                {{
                  currFormat(
                    getNonReccoRecords.reduce(
                      (acc, { fgr_quantity }) => acc + fgr_quantity,
                      0
                    )
                  )
                }}
              </th>
              <th>{{
                  currFormat(
                    getNonReccoRecords.reduce(
                      (acc, { transfer_in }) => acc + fgr_quantity,
                      0
                    )
                  )
                }}</th>
              <th>
                {{
                  currFormat(
                    getNonReccoRecords.reduce(
                      (acc, { transfer_out }) => acc + fgr_quantity,
                      0
                    )
                  )
                }}
              </th>
              <th>
                {{
                  currFormat(
                    getNonReccoRecords.reduce(
                      (acc, { standard_consumption }) =>
                        acc + standard_consumption,
                      0
                    )
                  )
                }}
              </th>
              <th>
                {{
                  currFormat(
                    getNonReccoRecords.reduce(
                      (acc, { system_stock }) => acc + system_stock,
                      0
                    )
                  )
                }}
              </th>
              <th>
                {{
                  currFormat(
                    getNonReccoRecords.reduce(
                      (acc, { wastage }) => acc + wastage,
                      0
                    )
                  )
                }}
              </th>
              <th>
                {{
                  currFormat(
                    getNonReccoRecords.reduce(
                      (acc, { ps_variance }) => acc + ps_variance,
                      0
                    )
                  )
                }}
              </th>
              <!-- <th>0.00</th> -->
              <th>
                {{
                  currFormat(
                    getNonReccoRecords.reduce(
                      (acc, { wastage, ps_variance }) =>
                        acc + (wastage + getOnlyPositiveNumber(ps_variance)),
                      0
                    )
                  )
                }}
              </th>
            </tr>
            <tr
              v-if="
                RawMaterialCategoryIndex == getCOGSReportData.length - 1 &&
                  false
              "
              style="text-align: right"
            >
              <th
                class="text-right"
                colspan="2"
                style="vertical-align: bottom; white-space: nowrap"
              >
                Non Reconcile Raw Material
              </th>
              <th class="font-weight-bold text-left">Value :</th>
              <th>
                {{
                  currFormat(
                    getNonReccoRecords.reduce(
                      (acc, { opening_stock, purchase_rate }) =>
                        acc + opening_stock * purchase_rate,
                      0
                    )
                  )
                }}
              </th>
              <th>
                {{
                  currFormat(
                    getNonReccoRecords.reduce(
                      (acc, { purchase, purchase_rate }) =>
                        acc + purchase * purchase_rate,
                      0
                    )
                  )
                }}
              </th>
              <th>
                {{
                  currFormat(
                    getNonReccoRecords.reduce(
                      (acc, { fgr_quantity, purchase_rate }) =>
                        acc + fgr_quantity,
                      0
                    )
                  )
                }}
              </th>
              <th>
                 {{
                  currFormat(
                    getNonReccoRecords.reduce(
                      (acc, { transfer_in, purchase_rate }) =>
                        acc + transfer_in * purchase_rate,
                      0
                    )
                  )
                }}
              </th>
              <th>
                {{
                  currFormat(
                    getNonReccoRecords.reduce(
                      (acc, { transfer_out, purchase_rate }) =>
                        acc + transfer_out * purchase_rate,
                      0
                    )
                  )
                }}
              </th>
              <th>
                {{
                  currFormat(
                    getNonReccoRecords.reduce(
                      (acc, { standard_consumption, purchase_rate }) =>
                        acc + standard_consumption * purchase_rate,
                      0
                    )
                  )
                }}
              </th>
              <th>
                {{
                  currFormat(
                    getNonReccoRecords.reduce(
                      (acc, { system_stock, purchase_rate }) =>
                        acc + system_stock * purchase_rate,
                      0
                    )
                  )
                }}
              </th>
              <th>
                {{
                  currFormat(
                    getNonReccoRecords.reduce(
                      (acc, { wastage, purchase_rate }) =>
                        acc + wastage * purchase_rate,
                      0
                    )
                  )
                }}
              </th>
              <th>
                {{
                  currFormat(
                    getNonReccoRecords.reduce(
                      (acc, { ps_variance, purchase_rate }) =>
                        acc + ps_variance * purchase_rate,
                      0
                    )
                  )
                }}
              </th>
              <!-- <th>0.00</th> -->
              <th>
                {{
                  currFormat(
                    getNonReccoRecords.reduce(
                      (acc, { wastage, ps_variance, purchase_rate }) =>
                        acc + (wastage + getOnlyPositiveNumber(ps_variance)) * purchase_rate,
                      0
                    )
                  )
                }}
              </th>
            </tr>

            <tr class="bg-lightgrey"
              v-if="RawMaterialCategoryIndex == getCOGSReportData.length - 1"
              style="text-align: right"
            >
              <th
                class="text-right"
                style="vertical-align: bottom; white-space: nowrap"
              >
                Grand Qty:
              </th>
              <th></th>
              <th class="font-weight-bold text-left">Qty :</th>
              <th>
                {{
                  currFormat(
                    getAllCOGSReportData.reduce(
                      (acc, { opening_stock }) => acc + opening_stock,
                      0
                    )
                  )
                }}
              </th>
              <th>
                {{
                  currFormat(
                    getAllCOGSReportData.reduce(
                      (acc, { purchase }) => acc + purchase,
                      0
                    )
                  )
                }}
              </th>
              <th>
                {{
                  currFormat(
                    getAllCOGSReportData.reduce(
                      (acc, { fgr_quantity }) => acc + fgr_quantity,
                      0
                    )
                  )
                }}
              </th>
              <th>
                 {{
                  currFormat(
                    getAllCOGSReportData.reduce(
                      (acc, { transfer_in }) => acc + transfer_in,
                      0
                    )
                  )
                }}
              </th>
              <th>
                {{
                  currFormat(
                    getAllCOGSReportData.reduce(
                      (acc, { transfer_out }) => acc + transfer_out,
                      0
                    )
                  )
                }}
              </th>
              <th>
                {{
                  currFormat(
                    getAllCOGSReportData.reduce(
                      (acc, { standard_consumption }) =>
                        acc + standard_consumption,
                      0
                    )
                  )
                }}
              </th>
              <th>
                {{
                  currFormat(
                    getAllCOGSReportData.reduce(
                      (acc, { system_stock }) => acc + system_stock,
                      0
                    )
                  )
                }}
              </th>
              <th>
                {{
                  currFormat(
                    getAllCOGSReportData.reduce(
                      (acc, { wastage }) => acc + wastage,
                      0
                    )
                  )
                }}
              </th>
              <th>
                {{
                  currFormat(
                    getAllCOGSReportData.reduce(
                      (acc, { ps_variance }) => acc + ps_variance,
                      0
                    )
                  )
                }}
              </th>
              <!-- <th>0.00</th> -->
              <th>
                {{
                  currFormat(
                    getAllCOGSReportData.reduce(
                      (acc, { wastage, ps_variance }) =>
                        acc + (wastage + getOnlyPositiveNumber(ps_variance)),
                      0
                    )
                  )
                }}
              </th>
            </tr>
            <tr class="bg-lightgrey"
              v-if="RawMaterialCategoryIndex == getCOGSReportData.length - 1"
              style="text-align: right"
            >
              <th
                class="text-right"
                style="vertical-align: bottom; white-space: nowrap"
              >
                Grand Total:
              </th>
              <th></th>
              <th
                class="font-weight-bold text-left"
                style="white-space: nowrap"
              >
                Value :
              </th>
              <th>
                {{
                  currFormat(
                    getAllCOGSReportData.reduce(
                      (acc, { opening_stock, purchase_rate }) =>
                        acc + opening_stock * purchase_rate,
                      0
                    )
                  )
                }}
              </th>
              <th>
                {{
                  currFormat(
                    getAllCOGSReportData.reduce(
                      (acc, { purchase, purchase_rate }) =>
                        acc + purchase * purchase_rate,
                      0
                    )
                  )
                }}
              </th>
              <th>
                {{
                  currFormat(
                    getAllCOGSReportData.reduce(
                      (acc, { fgr_quantity, purchase_rate }) =>
                        acc + fgr_quantity * purchase_rate,
                      0
                    )
                  )
                }}
              </th>
              <th>
                {{
                  currFormat(
                    getAllCOGSReportData.reduce(
                      (acc, { transfer_in, purchase_rate }) =>
                        acc + transfer_in * purchase_rate,
                      0
                    )
                  )
                }}
              </th>
              <th>
                {{
                  currFormat(
                    getAllCOGSReportData.reduce(
                      (acc, { transfer_out, purchase_rate }) =>
                        acc + transfer_out * purchase_rate,
                      0
                    )
                  )
                }}
              </th>
              <th>
                {{
                  currFormat(
                    getAllCOGSReportData.reduce(
                      (acc, { standard_consumption, purchase_rate }) =>
                        acc + standard_consumption * purchase_rate,
                      0
                    )
                  )
                }}
              </th>
              <th>
                {{
                  currFormat(
                    getAllCOGSReportData.reduce(
                      (acc, { system_stock, purchase_rate }) =>
                        acc + system_stock * purchase_rate,
                      0
                    )
                  )
                }}
              </th>
              <th>
                {{
                  currFormat(
                    getAllCOGSReportData.reduce(
                      (acc, { wastage, purchase_rate }) =>
                        acc + wastage * purchase_rate,
                      0
                    )
                  )
                }}
              </th>
              <th>
                {{
                  currFormat(
                    getAllCOGSReportData.reduce(
                      (acc, { ps_variance, purchase_rate }) =>
                        acc + getOnlyPositiveNumber(ps_variance) * purchase_rate,
                      0
                    )
                  )
                }}
              </th>
              <!-- <th>0.00</th> -->
              <th>
                {{
                  currFormat(
                    getAllCOGSReportData.reduce(
                      (acc, { wastage, ps_variance, purchase_rate }) =>
                        acc + (wastage + getOnlyPositiveNumber(ps_variance)) * purchase_rate,
                      0
                    )
                  )
                }}
              </th>
            </tr>
          </tbody>
        </table>
      </div>
     
    </div>
  </div>
</template>
<script>
import DatePicker from "vue2-datepicker";
import { mapState, mapGetters, mapActions } from "vuex";
import MasterService from "@/services/MasterService";
import NoRecords from "@/components/Partials/NoRecords.vue";
import xlsx from "json-as-xlsx";

export default {
  components: { DatePicker, NoRecords },
  data() {
    return {
      Cinemas: [],
      isRoleID: true,
      CinemasCopy: [],
      searchCinema: "",
      rawMaterialCategories: [],
      rawMaterialCategoriesCopy: [],
      searchRawMaterial: "",
      totalQty: 0,
      totalPurchase: 0
    };
  },
  computed: {
    ...mapGetters([
      
      "getCinemasList",
      "getRawMaterialCategoryList",
      "getCOGSSelectedCinema",
      "getCOGSSelectedRawMaterialCategory",
      "getCOGSReportFromDate",
      "getCOGSReportEndDate",
      "getCOGSReportData",
      "getAllCOGSReportData",
      "getNonReccoRecords",
      "getGlobalOptions",
      // EXCEL
      "getCOGSReportsExcelFileName",
      // PDF
      "getCOGSReportsPDFFileName"
    ])
  },
  mounted() {
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
    }
    let cinemaId =
      this.secureStore.get("USINFO") &&
      this.secureStore.get("USINFO")["cinema_id"]
        ? this.secureStore.get("USINFO").cinema_id
        : null;
    this.getCinemaList(cinemaId);
    // this.fetchCinemasList({ cinemaId });
    this.fetchRawMaterialCategory();
    this.getGrandTotal();
    this.ResetCOGSReport();
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    if (CinemaObj) {
      this.onCOGSDropDownHandler({
        event: null,
        name: "isCinema",
        selectedItem: CinemaObj
      });
    }
  },
  watch: {
    "$store.getters.getSelectedDropDownCinema": function(CinemaObj) {
      if (CinemaObj) {
        this.onCOGSDropDownHandler({
          event: null,
          name: "isCinema",
          selectedItem: CinemaObj
        });
      }
    }
  },
  methods: {
    getOnlyPositiveNumber(number) {
      let returnNumber = 0
      if(!number || isNaN(number)) {
        returnNumber = 0
      } else if(number > 0) {
        returnNumber = 0
      } else {
        returnNumber = Math.abs(number)
      }
      return returnNumber
    },
    // computedCogsData() {
    //   console.log(this.$store.getters.getCOGSReportData, "saf");
    //   let reportTotal = this.$store.getters.getCOGSReportData;
    //   let o_stock = 0;
    //   let purchase = 0;
    //   let purchase_return = 0;
    //   let t = [
    //     {
    //       purhcase_rate: 0,
    //       opening_stock: 0,
    //       purhcase: 0,
    //       purchase_return: 0,
    //       transfer_in: 0,
    //       transfer_out: 0,
    //       std_cons: 0,
    //       sys_stock: 0,
    //       wastage: 0,
    //       variance: 0,
    //       total_wastage: 0
    //     }
    //   ];
    //   reportTotal.map(x => {
    //     x.RawMaterials.map(y => {
    //       t.purhcase_rate=0+y.purchase_rate
    //       t.opening_stock=0 + y.opening_stock * y.purchase_rate
    //       t.purhcase=0+y.purchase
    //       t.purchase_return=0+y.fgr_quantity
    //       t.transfer_in=0
    //       t.transfer_out=0
    //       t.=0
    //       t.push({
    //         opening_stock: 0 + y.opening_stock * y.purchase_rate,
    //         purchase_return
    //       });
    //       o_stock = o_stock + y.opening_stock * y.purchase_rate;
    //       purchase = purchase + y.purchase;
    //       purchase_return = purchase_return + y.fgr_quantity;
    //       t = [...t, o_stock, purchase, purchase_return];
    //     });
    //   });
    //   console.log("a", o_stock);
    //   console.log("t", t);
    // },
    excelDownload() {
      console.log(this.getAllCOGSReportData);
      let temp_data = this.getAllCOGSReportData;
      // let temp_arr = [];
      // temp_data.map(x => {
      //   x.Rawmaterials.map(y => {
      //     let obj = {
      //       ...x,
      //       ...y,
            
      //     };
      //     temp_arr.push(obj);
      //   });
      // });
      // console.log({temp_arr})
      // let dateparse = function (value) {
      //   if (!value) return "-";
      //   else if (value === "Invalid date") return "-";
      //   else if (moment(value, "DD-MM-YYYY HH:mm", true).isValid())
      //     return value
      //       ? moment(value, "DD-MM-YYYY HH:mm").format("DD MMM YYYY")
      //       : "-";
      //   //else return value ? moment(value).format('DD-MM-YYYY') === 'Invalid date' ? '-' : moment(value).format('DD-MM-YYYY') : '-';
      //   //this is changed acc to mams decision
      //   else
      //     return value
      //       ? moment(value).format("DD-MM-YYYY") === "Invalid date"
      //         ? "-"
      //         : moment(value).format("DD MMM YYYY")
      //       : "-";
      // }
  //   let currFormat = function () {
  //   let cFormat;
  //   let precesion;
  //   let global_options_latest = this.getGlobalOptions;
  //   cFormat = global_options_latest.find(x => {
  //     return x.go_key == "CURR_FORMAT";
  //   });
  //   precesion = global_options_latest.find(x => {
  //     return x.go_key == "MIN_FRACTION_DIGITS";
  //   });
  //   if (cFormat && cFormat.go_value) {
  //     cFormat = cFormat.go_value;
  //   } else {
  //     cFormat = "en-US";
  //   }
  //   if (precesion && precesion.go_value) {
  //     precesion = precesion.go_value;
  //   } else {
  //     precesion = 2;
  //   }
  //   return getNumberFormatter(cFormat, precesion);
  // }

      let data = [
        {
          sheet: "COGS Report",
          columns: [
            {
              value: "rmc_category",
              label: "Category"
            },
              {
              value: "rm_name",
              label: "Raw Material"
            },
              {
              value: "uom_short_form",
              label: "UOM"
            },
              {
              value: row => +parseFloat(row.purchase_rate).toFixed(2),
              label: "Purchase Rate "
            },
              {
              value: "opening_stock",
              label: "Opening Stock"
            },
               {
              value: row => +parseFloat(row.opening_stock * row.purchase_rate),
              label: "Opening Stock Value"
            },
               {
              value: "purchase",
              label: "Purchase Quantity"
            },
               {
              value: row => +parseFloat(parseFloat(row.purchase) * parseFloat(row.purchase_rate)).toFixed(2),
              label: "Purchase Value"
            },
               {
              value: row => +parseFloat(row.fqr_quantity ? row.fqr_quantity : '0.00'),
              label: "Purchase Return"
            },
               {
              value: row => +parseFloat(parseFloat(row.fqr_quantity || 0) * parseFloat(row.purchase_rate || 0)).toFixed(2),
              label: "Purchase Return Value"
            },
              {
              value: row => +parseFloat(row.transfer_in ? row.transfer_in : '0.00'),
              label: "Transfer In From Unit"
            },
              {
              value: row => +parseFloat((row.transfer_in || 0) * row.purchase_rate).toFixed(2),
              label: "Transfer In Value"
            },
              {
              value: row => +parseFloat(row.transfer_out ? row.transfer_out : '0.00'),
              label: "Transfer Out Unit"
            },
             {
              value: row => +parseFloat((row.transfer_out || 0) * row.purchase_rate).toFixed(2),
              label: "Transfer Out Value"
            },
             {
              value: "standard_consumption",
              label: "Standard Combution"
            },
            {
              value: row => +parseFloat(row.standard_consumption * row.purchase_rate).toFixed(2),
              label: "Standard Combution Value"
            },
              {
              value: "system_stock",
              label: "System Stock"
            }, {
              value: row => +parseFloat(row.system_stock * row.purchase_rate).toFixed(2),
              label: "System Stock Value"
            },
              {
              value: "wastage",
              label: "Wastage"
            },
              {
              value: "ps_variance",
              label: "Variance"
            },
              {
              value: row => (row.wastage + this.getOnlyPositiveNumber(row.ps_variance)),
              label: "Total Wastage/Variance"
            },
            {
              value: row => (row.wastage + this.getOnlyPositiveNumber(row.ps_variance)) * (row.purchase_rate),
              label: "Total Wastage Value"
            },
            
           
            //      Sold: 0,
            // gross_amount: 0,
            // offer_price: 0,  
            // total_taxes: 0,
            // final_gross_amount: 0
          ],
          content: temp_data
        }
      ];
      let settings = {
        fileName: `COGS Report${new Date().getTime()}`
      };
      xlsx(data, settings);
    },
    onSelectCinema(cinema) {
      this.$store.dispatch("selectDropdownCinema", cinema);
    },
    onSearchRawMaterial: function(value) {
      if (this.searchRawMaterial && this.searchRawMaterial.length > 0) {
        this.rawMaterialCategories = this.rawMaterialCategoriesCopy.filter(
          x => {
            if (
              x.rmc_category
                .toLowerCase()
                .includes(this.searchRawMaterial.toLowerCase())
            ) {
              return x;
            }
          }
        );
      } else {
        this.rawMaterialCategories = this.rawMaterialCategoriesCopy;
      }
    },
    fetchRawMaterialCategory() {
      let body = {
        tableName: "ms_raw_material_category",
        rmc_is_active: "Y"
      };
      MasterService.GetActiveList(body)
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            this.rawMaterialCategories = data.Records;
            this.rawMaterialCategoriesCopy = data.Records;
            console.log(
              "this.rawMaterialCategories  :>> ",
              this.rawMaterialCategories
            );
          } else Vue.toasted.show(data.message || "Opps! Something went wrong");
        })
        .catch(error => {
          Vue.toasted.show(
            "Catch Error on MasterStore fetchCinemasList",
            error
          );
        });
    },
    onSearchCinema: function() {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.Cinemas = this.CinemasCopy.filter(x => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Cinemas = this.CinemasCopy;
      }
    },
    getCinemaList: function(cine_id) {
      this.Cinemas = [];
      //  let payload = null
      //   cine_id == null ?  payload = {tableName : 'ms_cinemas',cine_is_active: "Y"} : payload = {tableName : 'ms_cinemas',cine_is_active: "Y" ,cine_id : cine_id }
      MasterService.GetCinemas({ cine_id: cine_id })
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.CinemasCopy = data.Records;
            this.Cinemas.map(x => {
              if (String(cine_id) === String(x.cine_id)) {
                // let cinema = {
                //   cine_name: x.cine_name,
                //   cine_id: x.cine_id
                // };

                // this.onSelectCinema(null,cinema);
                this.onCOGSDropDownHandler({
                  name: "isCinema",
                  selectedItem: {
                    cine_name: x.cine_name,
                    cine_id: x.cine_id
                  }
                });
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    getGrandTotal() {
      console.log("data");
    },
    ...mapActions([
      //

      "onCOGSDropDownHandler",
      "ResetCOGSReport",
      "onFetchCOGSReports"
    ])
  }
};
</script>

<style scoped>
.sph-report th,
td {
  height: 30px;
}

.sph-report tbody tr,
td {
  white-space: normal !important;
}
.text_right{
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/cogsReport.vue